import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { SUBSCRIPTION_ALERT, WARNING_BANNER_IMG } from 'src/defaultImages.js';
import { LocalStorageService } from '../../services/localStorage.service';
import { CollectionInfrastructureHelperService } from 'src/app/collection-infrastructure/collection-infrastructure-helper.service';
import { Subscription } from 'rxjs';
import { EasyEatHqService } from '../../services/ee-hq.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-warning-banner',
  templateUrl: './warning-banner.component.html',
  styleUrls: ['./warning-banner.component.css'],
})
export class WarningBannerComponent implements OnInit, OnDestroy {
  complete: string = 'complete';
  images = {
    SUBSCRIPTION_ALERT: SUBSCRIPTION_ALERT,
    WARNING_BANNER_IMG: WARNING_BANNER_IMG,
  };
  renewYourSub: string = 'Renew your subscription ';
  promise: string;
  bannerType: number;
  isNegative: boolean;
  isHqUser: boolean = false;
  subscription: Subscription = new Subscription();
  translationText: any;

  constructor(
    private _local: LocalStorageService,
    private _ciHelperService: CollectionInfrastructureHelperService,
    private _cdr: ChangeDetectorRef,
    private _isHq: EasyEatHqService,
    private _translateService: TranslateService
  ) {}

  ngOnInit() {
    this.setTranslation();
    this.isHqUser = this._isHq.isHqUser();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setTranslation(): void {
    this.subscription.add(
      this._translateService.get('SHARED').subscribe((translation) => {
        this.translationText = translation;
        const bannerTypeSubscription = this._local
          .watch('bannerType')
          .subscribe((_) => {
            this.setBanner();
          });
        const nbBannerTypeSubscription = this._local
          .watch('nbBannerType')
          .subscribe((_) => {
            this.setBanner();
          });

        this.subscription.add(bannerTypeSubscription);
        this.subscription.add(nbBannerTypeSubscription);
      })
    );
  }

  setBanner() {
    const negativeBanner = Number(this._local.get('nbBannerType'));
    const subscriptionBanner = Number(this._local.get('bannerType'));
    this.isNegative = this._ciHelperService.isNegativeBalance();
    if (this.isNegative) {
      this.bannerType = negativeBanner;
      this.renewYourSub = `${this.translationText.CLEAR_DUE} `;
    } else {
      this.bannerType = subscriptionBanner;
      this.renewYourSub = `${this.translationText.RENEW_YOUR_SUB} `;
    }
    this._cdr.detectChanges();
  }

  renew() {
    this._ciHelperService.redirectToSubscriptionPage();
  }
}
